import React from 'react';
import Icon from '../atoms/Icon';

function CollegeIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 31">
      <g
        fill='none'
        fillRule='nonzero'
        stroke='currentColor'
        stroke-width='2.66667'
        stroke-miterlimit='10'
      >
        <path d='M0 29.4848H32'/>
        <path d='M2.66667 25.4848H29.3333'/>
        <path d='M26.6667 25.4848V10.8181'/>
        <path d='M5.33333 25.4848V10.8181'/>
        <path d='M10.6667 25.4848V10.8181'/>
        <path d='M16 25.4848V10.8181'/>
        <path d='M21.3333 25.4848V10.8181'/>
        <path d='M29.3333 8.15147H2.66667V8.01813L16 1.4848L29.3333 8.01813V8.15147Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(CollegeIcon);
